import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "identifying-information" }
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["data-testid", "aria-label"]
const _hoisted_8 = ["data-testid"]


import { RouteLocationRaw } from 'vue-router';

export interface Row {
    label: string;
    value?: string;
    valueOverride?: {
      component: any,
      props?: Object
    },
    to?: RouteLocationRaw;
    dataTestid?: string;
    valueDataTestid?: string;
    status?: 'success' | 'warning' | 'info' | 'error',
}

export interface MetadataProps {
  rows: Row[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    rows: {}
  },
  setup(__props: any) {



const getRowValueId = (row:Row): string => `value-${ row.label }:${ row.value }`.toLowerCase().replaceAll(' ', '');

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `${row.label}:${row.value}`,
        class: "row",
        "data-testid": row.dataTestid
      }, [
        _createElementVNode("label", {
          class: "label text-deemphasized",
          for: getRowValueId(row)
        }, _toDisplayString(row.label), 9, _hoisted_3),
        _cache[1] || (_cache[1] = _createTextVNode()),
        (typeof row.valueOverride?.component !== 'string' && row.valueOverride?.component && row.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: getRowValueId(row),
              class: "full-custom-value"
            }, [
              (row.valueOverride?.component)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(row.valueOverride?.component), _mergeProps({
                    key: 0,
                    ref_for: true
                  }, row.valueOverride?.props, {
                    "data-testid": row.valueDataTestid
                  }), null, 16, ["data-testid"]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_4))
          : (row.valueOverride?.component && row.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                id: getRowValueId(row),
                class: "value"
              }, [
                (row.valueOverride?.component)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(row.valueOverride?.component), _mergeProps({
                      key: 0,
                      ref_for: true
                    }, row.valueOverride?.props, {
                      "data-testid": row.valueDataTestid
                    }), null, 16, ["data-testid"]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("div", {
                key: 2,
                id: getRowValueId(row),
                class: "value"
              }, [
                (row.status)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(['status', row.status])
                    }, null, 2))
                  : _createCommentVNode("", true),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (row.value && row.to)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: row.to,
                      "data-testid": row.valueDataTestid
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.value), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "data-testid"]))
                  : (row.value)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        "data-testid": row.valueDataTestid,
                        tabindex: "0",
                        "aria-label": row.value
                      }, _toDisplayString(row.value), 9, _hoisted_7))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 3,
                        class: "text-muted",
                        "data-testid": row.valueDataTestid
                      }, "—", 8, _hoisted_8))
              ], 8, _hoisted_6))
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})